import type { ScheduleViewState } from "@/pages/human-resources/time-management/model/schedule-view/ScheduleViewState.ts";
import { ScheduleViewStateContext } from "@/pages/human-resources/time-management/model/schedule-view/ScheduleViewStateContext.ts";
import useDefinedContextValue from "@/shared/custom-hook/useDefinedContextValue.ts";

export default function useScheduleViewState(): ScheduleViewState {
  return useDefinedContextValue(ScheduleViewStateContext);
}
